import {
  Slider,
  Checkbox,
  Typography,
  FormControlLabel,
  Box,
  Divider,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { expectedLayers } from "../../../../settings/settings";
import { updateLayersMenuState } from "../../../../redux/reducers/menuSlice";
import { Fragment } from "react";

function ContextMenu() {
  const dispatch = useDispatch();
  const cityIOdata = useSelector((state) => state.cityIOdataState.cityIOdata);
  const layersMenuReduxState = useSelector(
    (state) => state.menuState.layersMenuState
  );

  // update the layer slider value
  const [sliderVal, setSliderVal] = useState(() => {
    const sv = {};
    for (const menuItem in expectedLayers) {
      sv[menuItem] = expectedLayers[menuItem].initSliderValue;
    }
    return sv;
  });

  // initial layer menu state
  const [layersMenuState, setLayersMenuState] = useState({});

  useEffect(() => {
  
    const combinedLayersMenuState = { ...layersMenuReduxState, ...layersMenuState };
    if(Object.keys(combinedLayersMenuState).length > 0)
      dispatch(updateLayersMenuState(combinedLayersMenuState));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layersMenuState]);

  const updateSliderVal = (menuItem, val) => {
    setSliderVal({ ...sliderVal, [menuItem]: val });
  };

  const handleCheckboxEvent = (menuItem, e) => {
    setLayersMenuState({
      ...layersMenuState,
      [menuItem]: {
        ...layersMenuState[menuItem],
        isOn: e,
      },
    });
  };

  const commitSliderVal = (menuItem, val) => {
    setLayersMenuState({
      ...layersMenuState,
      [menuItem]: {
        ...layersMenuState[menuItem],
        slider: val,
      },
    });
  };

  const toggleListArr = [];
  const makeLayerControlsMenu = () => {
    // loop through the keys in deckgl layers
    
    let newLayersMenuState = {}
    let updateState = false
    if(cityIOdata.layers)
      for (let i = 0; i < cityIOdata.layers.length; i++) {
        if(cityIOdata.layers[i].properties.context === false){
          continue;
        }
        if(cityIOdata.layers[i].properties.base === true){
          const moduleName = cityIOdata.layers[i].id;
        
          if(!layersMenuState[moduleName]){
            newLayersMenuState[moduleName] = {
              isOn: true,
              slider: 75,
            };
            updateState = true
          }
  
          continue;
        }
        const moduleName = cityIOdata.layers[i].id;
        
        if(!layersMenuState[moduleName]){
          newLayersMenuState[moduleName] = {
            isOn: true,
            slider: 50,
          };
          updateState = true
        }

        // if the module name is in the data for this CS instance, make a checkbox
        toggleListArr.push(
          <Fragment key={"fragment_" + moduleName} >
          <Box key={"box_" + moduleName} sx={{width: '100%', display: 'flex', alignItems: 'center'}
          }>
            <FormControlLabel
              key={"formControl_" + moduleName}
              control={
                <Checkbox
                  checked={
                    (layersMenuState[moduleName] &&
                      layersMenuState[moduleName].isOn) ||
                    false
                  }
                  key={"checkbox_" + moduleName}
                  color="primary"
                  onChange={(e) =>
                    handleCheckboxEvent(moduleName, e.target.checked)
                  }
                />
              }
              label={
                <Typography variant="caption" key={"label_" + moduleName}>
                  {moduleName}
                </Typography>
              }
            />
              </Box>

            {layersMenuState[moduleName] && layersMenuState[moduleName].isOn && (
              <Slider
                size="small"
                key={"slider_" + moduleName}
                valueLabelDisplay="auto"
                onChangeCommitted={(_, val) => commitSliderVal(moduleName, val)}
                onChange={(_, val) => updateSliderVal(moduleName, val)}
                value={sliderVal[moduleName] ?? 50}
                min={1}
              />
            )}
            <Divider orientation="horizontal" variant="middle" flexItem />

            </Fragment>
        );
        
      }
      if(updateState){
        setLayersMenuState({...layersMenuState,...newLayersMenuState})
      }
    return toggleListArr;
  };

  return makeLayerControlsMenu();
}

export default ContextMenu;
